import type { CSSProperties } from 'react';

import { classNames } from '@/utils/classNames';

import styles from './Icon.module.css';

type IconProps = {
  svg: string;
  size?: number;
  /** Drawable size inside the frame (e.g. Material icon glyph in a 24dp grid). */
  glyphWidth?: number;
  glyphHeight?: number;
  color?: string;
  className?: string;
  style?: CSSProperties;
};

export const Icon = ({
  svg,
  size = 24,
  glyphWidth,
  glyphHeight,
  color = 'currentColor',
  className,
  style,
}: IconProps) => {
  const glyphSized = glyphWidth != null && glyphHeight != null;

  return (
    <span
      className={classNames(styles.root, glyphSized && styles.rootGlyphSized, className)}
      aria-hidden
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: size,
        height: size,
        color,
        lineHeight: 0,
        ...(glyphSized
          ? ({
              '--icon-glyph-w': `${String(glyphWidth)}px`,
              '--icon-glyph-h': `${String(glyphHeight)}px`,
            } as CSSProperties)
          : {}),
        ...style,
      }}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};
